import React from "react";
import PropTypes from "prop-types";
import AddCustomerRow from "./AddCustomerRow";
import EditCustomerRow from "./EditCustomerRow";
import ViewCustomerRow from "./ViewCustomerRow";

const CustomerRow = (props) => {
  const { mode } = props;
  if (mode === "add") {
    return <AddCustomerRow {...props} />;
  } else if (mode === "edit") {
    return <EditCustomerRow {...props} />;
  } else {
    return <ViewCustomerRow {...props} />;
  }
};

CustomerRow.propTypes = {
  mode: PropTypes.oneOf(["add", "edit", "view"]).isRequired,
  customer: PropTypes.object,
  index: PropTypes.number,
  selectedCustomer: PropTypes.object,
  onRowClick: PropTypes.func,
  customerOptions: PropTypes.array,
  addCustomer: PropTypes.func,
  handlers: PropTypes.object,
  handleAutoSave: PropTypes.func,
  newCustomerId: PropTypes.string,
  setNewCustomerId: PropTypes.func,
};

export default CustomerRow;
